import { SkeletonSpinnerCentered } from '@civilgrid/ui/SkeletonLoader';
import { useParams } from '@tanstack/react-router';
import { useAsync } from 'react-use';
import { getProjectSummary } from '~/api/projects2';
import type { ProjectDetailsParams } from '..';
import Section from './Section';
import UpgradeButton from './UpgradeButton';

export default function LandRights() {
  const { projectId } = useParams({ strict: false }) as ProjectDetailsParams;
  const res = useAsync(async () => {
    return await getProjectSummary<{ parcels: number }>(projectId, 'landRights');
  }, [projectId]);

  if (res.error) {
    console.error(res.error);
    return null;
  }

  return (
    <Section icon="📄" title="Land Rights">
      {res.loading ? (
        <SkeletonSpinnerCentered />
      ) : (
        <div className="space-y-2">
          <div className="text-sm">
            Your project area includes <span className="font-semibold">{res.value!.parcels}</span> parcels! Upgrade now
            to access
            <div className="my-2 grid grid-cols-2">
              <div>Prelim Title</div>
              <div>Chain of Title</div>
              <div>Assessor Map Reports</div>
              <div>Lien Report</div>
              <div>Transaction History</div>
              <div>Detailed zoning</div>
            </div>
          </div>

          <UpgradeButton>View Land Rights</UpgradeButton>
        </div>
      )}
    </Section>
  );
}
